/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_M2_HourInputs */

const cs_enum_m2_hour = /** @type {(inputs: Enum_M2_HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m² / hodina`)
};

const en_enum_m2_hour = /** @type {(inputs: Enum_M2_HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m² / hour`)
};

/**
* | output |
* | --- |
* | "m² / hour" |
*
* @param {Enum_M2_HourInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_m2_hour = /** @type {((inputs?: Enum_M2_HourInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_M2_HourInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_m2_hour(inputs)
	return cs_enum_m2_hour(inputs)
});